/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { theme } from "@nordcloud/gnui";

/** Last pixel width before gnui `md` breakpoint (768px). */
export const MOBILE_MAX_WIDTH = theme.breakpoints.md - 1;
